export default {
    error_consulting_books: 'Hubo un error consultando libros.',
    no_books_found: 'No se encontraron libros.',
    search_result: 'Resultado de la búsqueda',
    title_carousel_1: 'Mis libros favoritos',
    title_carousel_2: 'Los 10 libros más solicitados',
    title_carousel_3: 'Los 10 libros mejor evaluados',
    title_carousel_4: 'Novedades',
    title_carousel_5: 'Mis libros comprados',
    title_button_card: 'Abrir este libro',
    not_books_data: 'Sin libros para mostrar',
    book_tittle_required: 'El título del libro es requerido'
}
